import { useMemo } from "react"

export const useTabCounts = (selectedTrip, confirmedSearchQuery, activeListingTab, metadata, originalStatusCount) => {
  return useMemo(() => {
    const getSelectedTripCount = (tabKey) => {
      return tabKey === activeListingTab ? 1 : 0
    }

    const getSearchQueryCount = (tabKey) => {
      return tabKey === activeListingTab ? metadata?.total_results || 0 : 0
    }

    const getStatusCount = (tabKey) => {
      const statusCount = originalStatusCount || metadata?.status_count
      if (!statusCount) return 0
      
      switch (tabKey) {
        case "published":
          return statusCount.published || 0
        case "draft":
          return statusCount.draft || 0
        case "unpublished":
          return statusCount.unpublished || 0
        default:
          return 0
      }
    }

    const getTabCount = (tabKey) => {
      if (selectedTrip) {
        return getSelectedTripCount(tabKey)
      }
      
      if (confirmedSearchQuery) {
        return getSearchQueryCount(tabKey)
      }
      
      return getStatusCount(tabKey)
    }

    return {
      publishedCount: getTabCount("published"),
      draftCount: getTabCount("draft"),
      unpublishedCount: getTabCount("unpublished")
    }
  }, [selectedTrip, confirmedSearchQuery, activeListingTab, metadata, originalStatusCount])
}
